import { InboxFilterForm } from '../../model/inbox-form-filter.model';

export class SaveFilterForm {
	static readonly type = '[Intelligence][Inbox] SaveFilterForm';

	constructor(public payload: InboxFilterForm) {}
}

export class SelectedOrderID {
	static readonly type = '[Intelligence][Inbox] SelectedOrder';
	constructor(public orderId: number) {}
}

export class SelectedRowOrder {
	static readonly type = '[Intelligence][Inbox] SelectedRowOrder';
	constructor(public payload: number) {}
}
